import React, { useState } from 'react';
import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifButton,
  MotifIcon,
} from '@ey-xd/motif-react';
import { alertIcError24px } from '@ey-xd/motif-react/assets/icons';
import {
  MessageParagraph,
  ModalHeaderContainer,
} from '@organisms/modals/styles/plOpportunityNameModal.styles';
import { NO_USER_FOUND_MODAL } from '@constants/commonConstants';
import { useSetRecoilState } from 'recoil';
import { Open_Super_User_Modal_State } from '@recoil/recoil';

const NoUserFoundModal = () => {
  const [showDangerModal, setShowDangerModal] = useState(true);
  const setOpenSuperUserModal = useSetRecoilState(Open_Super_User_Modal_State);

  const closeDangerModal = () => {
    setShowDangerModal(false);
  };

  const onEnterAnotherEmailClicked = () => {
    setOpenSuperUserModal(true);
  };

  return (
    <MotifModal
      size="sm"
      variant="alt"
      show={showDangerModal}
      onClose={closeDangerModal}
      focusTrapOptions={{
        initialFocus: false,
      }}
    >
      <MotifModalHeader title="Close opportunity details modal" closeModalButton={true}>
        <ModalHeaderContainer>
          <MotifIcon style={{ color: '#F95D54', paddingRight: '10px' }} src={alertIcError24px} />
          {NO_USER_FOUND_MODAL.HEADER_TITLE}
        </ModalHeaderContainer>
      </MotifModalHeader>
      <MotifModalBody>
        <MessageParagraph>
          {NO_USER_FOUND_MODAL.DESCRIPTION_1}
          <b>{localStorage.getItem('targetUserEmail')}</b> {NO_USER_FOUND_MODAL.DESCRIPTION_2}
        </MessageParagraph>

        <MessageParagraph>{NO_USER_FOUND_MODAL.DESCRIPTION_3}</MessageParagraph>
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton variant="secondary" type="button" onClick={onEnterAnotherEmailClicked}>
          {NO_USER_FOUND_MODAL.BUTTON_TITLE}
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
};

export default NoUserFoundModal;
